// All Swiper slider JS
var collectionSlider = new Swiper(".collection_slider_swiper", {
  slidesPerView: 2,
  spaceBetween: 8,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  loop: true,
  breakpoints: {
    388: {
      slidesPerView: 3,
      spaceBetween: 8,
    },
    576: {
      slidesPerView: 4,
      spaceBetween: 8,
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
    1400: {
      slidesPerView: 6,
      spaceBetween: 24,
    },
  },
});

var selectionSlider = new Swiper(".selection_slider_swiper", {
  slidesPerView: 1,
  spaceBetween: 12,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  loop: true,
  breakpoints: {
    388: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
    576: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 12,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1400: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
});

let bestSellerSlider = new Swiper(".best_seller_slider", {
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  loop: true,
  breakpoints: {
    388: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1400: {
      slidesPerView: 4,
      spaceBetween: 49,
    },
  },
});

let cartDrawerrec;

function initCartSwiper() {
  console.log("initCartSwiper");
  if (cartDrawerrec) {
    cartDrawerrec.destroy(true, true); // Destroy existing instance if it exists
  }

  cartDrawerrec = new Swiper(".cart_drawer_recommendation_products", {
    slidesPerView: "auto",
    spaceBetween: 8,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  jQuery(".cart_drawer_wrapper").removeClass("loading");
  jQuery(".quantity-selector__button-wrapper").each(function () {
    var itemElement = jQuery(this).closest(".cart_drawer_product_block");
    var qtyInput = itemElement.find('[name="updates[]"]');
    if (qtyInput.val() != 1) {
      jQuery(this).removeClass("quantity-selector__button-wrapper--disabled");
    }
  });
}

setTimeout(function () {
  var swiper = new Swiper(".product_rec_slider", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      389: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
    },
  });
}, 2000);
var swiper = new Swiper(".template-cart .best_seller_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  // loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    389: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 0,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 0,
    },
  },
});

// Collection Description Read more content
// document.addEventListener("DOMContentLoaded", function() {
//   // Get the elements
//   var readMoreBtn = document.getElementById("read-more");
//   var readLessBtn = document.getElementById("read-less");
//   var truncatedDescription = document.getElementById("truncated_description");
//   var fullDescription = document.getElementById("full_description");

//   // Check if elements exist before adding event listeners
//   if (readMoreBtn && readLessBtn && truncatedDescription && fullDescription) {
    
//     // Add click event listener for "Read More"
//     readMoreBtn.addEventListener("click", function() {
//       truncatedDescription.style.display = "none"; // Hide truncated description
//       fullDescription.style.display = "block";     // Show full description
//     });

//     // Add click event listener for "Read Less"
//     readLessBtn.addEventListener("click", function() {
//       fullDescription.style.display = "none";      // Hide full description
//       truncatedDescription.style.display = "block"; // Show truncated description
//     });
//   }
// });

jQuery(document).ready(function () {
  var readMoreBtn = jQuery('#read-more');
  
  jQuery('#read-more').click(function (e) {
    var text = jQuery(this).text();
    console.log(text);
    e.preventDefault();
    jQuery(this).parent('.collection--description-toggle').toggleClass('active');
    if(text === 'Read More') {
      jQuery(this).text('Read Less');
    }else {
      jQuery(this).text('Read More');
    }
  });
  
})

// Toggle search bar in responsive device
// const searchBtn = document.querySelector(".live_search_icon a");
// const liveSearch = document.querySelector(".live-search");
// const liveSearchClose = document.querySelector(".live-search-close-btn");
// const liveSearchDimmer = document.querySelector('[data-site-main-dimmer]');

// searchBtn.addEventListener("click", function () {
//   liveSearch.classList.toggle("active_search");
//     setTimeout(() => {
//   document.querySelector(".live-search.active_search .live-search-form-field").focus();
//     }, 200);
// });
// liveSearchClose.addEventListener("click", function () {
//   liveSearch.classList.remove("active_search");
//   this._closeFlyDown();
// });

document.addEventListener("click", function (e) {
  if (!e.target.classList.contains("toggle")) return;

  e.preventDefault();

  const toggle = e.target;
  const nextElement = toggle.nextElementSibling;
  const accordionItem = toggle.closest(".accordion_item");

  if (nextElement.classList.contains("show")) {
    // Collapse the section
    nextElement.style.maxHeight = nextElement.scrollHeight + "px"; // Set max-height to current height for smooth transition
    setTimeout(() => {
      nextElement.style.maxHeight = "0";
    }, 0);
    nextElement.classList.remove("show");
    accordionItem.classList.remove("active_accordion");
  } else {
    // Close other open sections
    document.querySelectorAll(".accordion_item .inner.show").forEach((el) => {
      el.style.maxHeight = el.scrollHeight + "px"; // Set max-height to current height before collapsing for smooth transition
      setTimeout(() => {
        el.style.maxHeight = "0";
      }, 0);
      el.classList.remove("show");
      el.closest(".accordion_item").classList.remove("active_accordion");
    });

    // Open the clicked section and add 'active_accordion' class
    nextElement.classList.add("show");
    nextElement.style.maxHeight = nextElement.scrollHeight + "px";
    accordionItem.classList.add("active_accordion");

    // Remove maxHeight after the animation to fit content dynamically
    nextElement.addEventListener(
      "transitionend",
      function () {
        if (nextElement.classList.contains("show")) {
          nextElement.style.maxHeight = "fit-content";
        }
      },
      { once: true }
    );
  }
});

// Filter
const rangeStart = document.getElementById("rangeStart");
const rangeEnd = document.getElementById("rangeEnd");
const startValue = document.getElementById("startValue");
const endValue = document.getElementById("endValue");

function updateValues() {
  // Ensure the start value doesn't exceed the end value
  if (parseInt(rangeStart.value) > parseInt(rangeEnd.value)) {
    rangeStart.value = rangeEnd.value;
  }

  // Ensure the end value doesn't go below the start value
  if (parseInt(rangeEnd.value) < parseInt(rangeStart.value)) {
    rangeEnd.value = rangeStart.value;
  }

  // Update the display of values
  startValue.textContent = rangeStart.value;
  endValue.textContent = rangeEnd.value;
}

// Add event listeners for both sliders
if (rangeStart && rangeEnd) {
  rangeStart.addEventListener("input", updateValues);
  rangeEnd.addEventListener("input", updateValues);
}

// FAQS
// jQuery(document).on('click', '.toggle', function(e) {
//   e.preventDefault();

//   let $this = $(this);
//   let $nextElement = $this.next('.inner');
//   let $accordionItem = $this.closest('.accordion_item');

//   if ($nextElement.hasClass('show')) {
//       // Remove 'show' class and slide up the current section
//       $nextElement.removeClass('show').slideUp(350);
//       $accordionItem.removeClass('active_accordion');
//   } else {
//       // Close other open sections
//       $('.accordion_item .inner.show').removeClass('show').slideUp(350);
//       $('.accordion_item').removeClass('active_accordion');

//       // Open the clicked section and add 'active_accordion' class
//       $nextElement.addClass('show').slideDown(350);
//       $accordionItem.addClass('active_accordion');
//   }
//   });

//append faq for collection pages
// Function to extract FAQs from HTML content
function extractFAQs() {
  // Select all the FAQ titles (h4) and corresponding answers (p)
  const faqTitles = document.querySelectorAll("h4 span"); // Get all the FAQ titles
  const faqArray = [];

  // Loop through each title element

  faqTitles.forEach((titleElement) => {
    let toRemovetitle = titleElement;
    const title = titleElement.innerText; // Get the title text
    let answerElements = []; // To store answer paragraphs
    let sibling = titleElement.parentElement.nextElementSibling; // Get the next sibling after h4

    // Loop through the following sibling elements that are paragraphs (answers)

    while (sibling) {
         if (sibling.tagName === "H4") {
        break; // Stop the loop if we encounter another h4
      }
      let toRemove = sibling;
      answerElements.push(sibling.innerHTML); // Add each paragraph's text to answer array
      sibling = sibling.nextElementSibling; // Move to the next sibling
      toRemove.remove();
    }

    // Join the answer paragraphs into a single string and add to the array
    faqArray.push({ title, answer: answerElements.join("\n") });
    toRemovetitle.remove();
  });

  return faqArray;
}

// Call the function to get the FAQs in array format

// Function to generate FAQ HTML template
function generateFAQHTML(faqArray) {
  return faqArray
    .map(
      (faq) => `
      <li class="accordion_item">
          <div class="accordion_header toggle">${faq.title}</div>
          <div class="accordion_body inner">
              <div class="para">${faq.answer}</div>
          </div>
      </li>
  `
    )
    .join("");
}

// Function to append the generated FAQ items to the accordion card
function appendFAQsToAccordion(faqArray) {
  const accordionCard = document.querySelector(".accordion_card"); // Get the .accordion_card element
  if (!accordionCard) return; // Make sure the element exists

  const faqHTML = generateFAQHTML(faqArray); // Generate the HTML content for the FAQs
  accordionCard.innerHTML += faqHTML; // Append the FAQ content to the accordion
  const faqs_wrapper = document.querySelector(".faqs_wrapper"); // Get the .faqs_wrapper element
  if (faqs_wrapper) {
    faqs_wrapper.classList.remove("d-none"); // Remove the 'd-none' class if element exists
  }
}

const text_truncate = document.querySelector(".collection--description"); // Get the .faqs_wrapper element
if (text_truncate) {
  if (text_truncate.innerHTML.includes("Frequently asked questions") || text_truncate.innerHTML.includes("Frequently Asked Questions") || text_truncate.innerHTML.includes("FREQUENTLY ASKED QUESTIONS")) {
    appendFAQsToAccordion(extractFAQs());
    text_truncate.innerHTML = text_truncate.innerHTML.replace(
      "Frequently asked questions",
      ""
    );
     text_truncate.innerHTML = text_truncate.innerHTML.replace(
      "Frequently Asked Questions",
      ""
    );
     text_truncate.innerHTML = text_truncate.innerHTML.replace(
      "FREQUENTLY ASKED QUESTIONS",
      ""
    );
  }
}

// Function to fetch product data
function fetchProductData(handle) {
  return fetch(`/products/${handle}.js`)
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error("Error fetching product data:", error);
    });
}

// Function to find the correct variant based on selected options
function findVariant(product, selectedOptions) {
  return product.variants.find(function (variant) {
    return variant.options.every(function (option, index) {
      return option === selectedOptions[index];
    });
  });
}

// Example function to handle the process after fetching product data
function setupVariantSelection(product, productbox) {
 // console.log(productbox);

  $(productbox)
    .find('input[type="radio"]')
    .on("change", function () {
      // Get all the currently selected options
      var selectedOptions = [];
      $(productbox)
        .find('input[type="radio"]:checked')
        .each(function () {
          selectedOptions.push($(this).val());
        });

      // Find the variant corresponding to the selected options
      var selectedVariant = findVariant(product, selectedOptions);
//console.log(selectedVariant);
      if (selectedVariant) {
           $(productbox)
          .find(".product_option_size span")
          .html(`${selectedVariant.title}`);
        $(productbox)
          .find(".product_option_price .sale-price")
          .html(`$${(selectedVariant.price / 100).toFixed(2)}`);
        $(productbox)
          .find("[data-quick-buy]")
          .attr("data-variant-id", selectedVariant.id);
        $(productbox).find("[data-quick-buy]").removeAttr("disabled");
      } else {
        console.log("Variant not found.");
      }
    });
}
/*
  function setupVariantSelection(product, productbox) {
    console.log(productbox);
    productbox.querySelectorAll('input[type="radio"]').forEach(function(input) {
      input.addEventListener('change', function() {
        // Get all the currently selected options
        var selectedOptions = [];
        productbox.querySelectorAll('input[type="radio"]:checked').forEach(function(checkedInput) {
          selectedOptions.push(checkedInput.value);
        });
        // Find the variant corresponding to the selected options
        var selectedVariant = findVariant(product, selectedOptions);

        if (selectedVariant) {
          productbox.querySelector('.product_option_price .sale-price').innerHTML = `$${(selectedVariant.price / 100).toFixed(2)}`;
          productbox.querySelector('[data-quick-buy]').setAttribute("data-variant-id", selectedVariant.id);
           productbox.querySelector('[data-quick-buy]').removeAttribute("disabled");
        } else {
          console.log('Variant not found.');
        }
      });
    });
  }

*/

/*

var dataquickshop_slim_newAll = document.querySelectorAll("[data-quickshop-slim-new]");

if (dataquickshop_slim_newAll.length > 0) {
  dataquickshop_slim_newAll.forEach(function(dataquickshop_slim_new) {
    console.log("productitem");
    var productbox = dataquickshop_slim_new.closest(".productitem");

    // Caching selectors to avoid querying the DOM multiple times
    var productOptionContainer = productbox.querySelector(".product_option_container");
    var closeOption = productbox.querySelector(".close_option");

    dataquickshop_slim_new.addEventListener("click", function(event) {

      if (productOptionContainer) {

        productOptionContainer.classList.remove("d-none");
        productOptionContainer.classList.add('active');
        var option_box = productOptionContainer.querySelectorAll(".option_box");
        if(option_box.length > 1 ){
        fetchProductData(dataquickshop_slim_new.getAttribute("data-handle")).then(function(product) {
            setupVariantSelection(product, productOptionContainer);
        });
        }
        else
        {
         productbox.querySelector('[data-quick-buy]').removeAttribute("disabled");
        }
      }
    });

    // Checking if closeOption exists before attaching an event listener
    if (closeOption) {
      closeOption.addEventListener("click", function(event) {
        event.preventDefault();
        if (productOptionContainer) {
          productOptionContainer.classList.remove("active");
        }
      });
    }
  });
}*/

// Post Tabs JS
const tabBtns = document.querySelectorAll(".tab-menu li a");
if (tabBtns) {
  tabBtns.forEach((anchor) => {
    anchor.addEventListener("click", function (event) {
      event.preventDefault();
      const target = this.getAttribute("data-rel");

      document
        .querySelector(".tab-menu li a.active")
        ?.classList.remove("active");
      this.classList.add("active");

      document
        .querySelectorAll(".tab-box")
        .forEach((box) => (box.style.display = "none"));
      document.getElementById(target).style.display = "block";
    });
  });
}

jQuery(document).on("click", "[data-quickshop-slim-new]", function (event) {
  console.log("productitem");

  var $dataquickshop_slim_new = jQuery(this); // Current element
  var $productbox = $dataquickshop_slim_new.closest(".productitem");

  // Caching selectors to avoid querying the DOM multiple times
  var $productOptionContainer = $productbox.find(".product_option_container");
  var $closeOption = $productbox.find(".close_option");

  if ($productOptionContainer.length) {
    $productOptionContainer.removeClass("d-none").addClass("active");

    var $option_box = $productOptionContainer.find(".option_box");
    if ($option_box.length > 1) {
      fetchProductData($dataquickshop_slim_new.data("handle")).then(function (
        product
      ) {
        setupVariantSelection(product, $productOptionContainer);
      });
    } else {
      $productbox.find("[data-quick-buy]").removeAttr("disabled");
    }
  }

  // Close option functionality
  if ($closeOption.length) {
    $closeOption.on("click", function (event) {
      event.preventDefault();
      $productOptionContainer.removeClass("active");
    });
  }
});

function ReCallCartDrawer(CartResponse) {
  console.log(CartResponse);
  if(CartResponse !== undefined && CartResponse !== null)
  {
    jQuery(".site-header-cart--count").attr("data-header-cart-count", CartResponse.item_count)
  }
  fetch("/") // Replace with the correct endpoint
    .then((response) => response.text()) // Get the full HTML response
    .then((data) => {
      // Parse the HTML string to a DOM object
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "text/html");

      // Find the specific div you want to extract from the fetched HTML
      let newCartDrawer = doc.querySelector("#cart_drawer_wrapper");

      if (newCartDrawer) {
        // Replace the current cart_drawer_wrapper with the new one
        document.getElementById("cart_drawer_wrapper").innerHTML =
          newCartDrawer.innerHTML;
        initCartSwiper();
      } else {
        console.error("Could not find cart_drawer_wrapper in the fetched HTML");
      }
    })
    .catch((error) => {
      console.error("Error fetching cart content:", error);
    });
}

jQuery(document).on("click", ".site-header-cart--button", function (event) {
  event.preventDefault();
  jQuery(".cart_drawer_wrapper").addClass("active");
  jQuery("body").addClass("show_cart");
});
jQuery(document).on("click", ".cart_drawer_close_btn", function (event) {
  jQuery(".cart_drawer_wrapper").removeClass("active");
  jQuery("body").removeClass("show_cart");
});
jQuery(document).on("click", ".cart_drawer_wrapper .remove", function (event) {
  jQuery(".cart_drawer_wrapper").addClass("loading");
  let removebutton = jQuery(this);
  jQuery
    .ajax({
      type: "GET",
      url: removebutton.attr("data-href"),
      dataType: "json",
    })
    .done((secondResponse) => {
      ReCallCartDrawer(secondResponse);
    });
});

//
document.addEventListener("wishlist-hero-wishlist-sdk-ready", async function (e) {
    if(jQuery('#wishlist-hero-product-page-button'))
    {
      setTimeout(function(){
      if(jQuery('#wishlist-hero-product-page-button button').attr("title") !== "Add to wishlist"){
         jQuery('.mobilewishlist button').html(jQuery('#wishlist-hero-product-page-button button').html());
      }
      }, 2000);
    }

  
});
jQuery(document).ready(function () {

  if(jQuery('body').hasClass("template-index"))
  {
   
    var reviewinterval = setInterval(function(){
      if(jQuery(".grp-entangle-head-badge").length)
      {
        jQuery(".grp-entangle-head-badge").append('<a href="https://www.google.com/maps/search/?api=1&query=Google&query_place_id=ChIJ4UjeLYJn1moRTdv4b0kJbmw" class="button-primary" target="_blank" type="submit">SEE MORE REVIEWS & INFO</a>');
        clearInterval(reviewinterval);
      }
     
    }, 500)
  }
  initCartSwiper();
  jQuery("[data-quick-buy]").removeAttr("disabled");

  
  jQuery('.mobilewishlist').on('click', function(){
    jQuery("#wishlist-hero-product-page-button button").trigger("click");
      setTimeout(function(){
    
         jQuery('.mobilewishlist button').html(jQuery('#wishlist-hero-product-page-button button').html());
      
      }, 2000);
    });

  
/*
$('.js-load-more').on('click', function(){
  var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  $this.attr('disabled', true);
  $this.find('[load-more-text]').addClass('hide');
  $this.find('[loader]').removeClass('hide');
  var requestpage = parseInt(currentPage)+1;
  var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+requestpage);
  $('[data-current-page]').val(requestpage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.productgrid--items').append($(responseHTML).find('.productgrid--items').html());
   
    },
    complete: function() {
      if(requestpage <= totalPages) {
         $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
      } 
       if(requestpage == totalPages) {
         $this.attr('disabled', true);
         $this.addClass("hide");
      }
    }
  })
});
*/
  
});
jQuery(document).on(
  "click", ".cart_checkout_top svg", function(){
jQuery(".cart-shipping-toggle").click();
})
jQuery(document).on(
  "click",
  '.cart_drawer_wrapper [name="minus"]',
  function (event) {
    var itemElement = jQuery(this).closest(".cart_drawer_product_block");
    var qtyInput = itemElement.find('[name="updates[]"]');
    qtyInput.val(parseInt(qtyInput.val()) - 1);
    jQuery(".cart_drawer_wrapper").addClass("loading");
    jQuery
      .ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { quantity: qtyInput.val(), id: itemElement.attr("data-key") },
        dataType: "json",
      })
      .done((secondResponse) => {
        ReCallCartDrawer(secondResponse);
      });

    if (qtyInput.val() == 1) {
      jQuery(this)
        .parent()
        .addClass("quantity-selector__button-wrapper--disabled");
    }
  }
);

jQuery(document).on(
  "click",
  '.cart_drawer_wrapper [name="plus"]',
  function (event) {
    var itemElement = jQuery(this).closest(".cart_drawer_product_block");
    var qtyInput = itemElement.find('[name="updates[]"]');
    qtyInput.val(parseInt(qtyInput.val()) + 1);
    jQuery(".cart_drawer_wrapper").addClass("loading");
    jQuery
      .ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { quantity: qtyInput.val(), id: itemElement.attr("data-key") },
        dataType: "json",
      })
      .done((secondResponse) => {
        ReCallCartDrawer(secondResponse);
      });
  }
);

jQuery(document).on(
  "focusout",
  '.cart_drawer_wrapper [name="updates[]"]',
  function (event) {
    var itemElement = jQuery(this).closest(".cart_drawer_product_block");
    var qtyInput = itemElement.find('[name="updates[]"]');
    //console.log("qtyupdates");
    jQuery(".cart_drawer_wrapper").addClass("loading");
    jQuery
      .ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { quantity: qtyInput.val(), id: itemElement.attr("data-key") },
        dataType: "json",
      })
      .done((secondResponse) => {
        ReCallCartDrawer(secondResponse);
      });
  }
);

jQuery(document).on(
  "click",
  ".cart_drawer_wrapper .add_to_cart",
  function (event) {
    jQuery(".cart_drawer_wrapper").addClass("loading");
    event.preventDefault();
    const CartButton = jQuery(this);
    let formData = {
      items: [
        {
          id: CartButton.attr("data-variant-id"),
          quantity: 1,
        },
      ],
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        //console.log(response.json());
        ReCallCartDrawer(response);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
);

jQuery(document).on("click", ".cart_drawer_gift_form_open", function(event){
  event.preventDefault();
  jQuery(".cart_drawer_gift_form").slideToggle();
  jQuery(".cart_drawer_gift_form_open").slideToggle();
})


// FAQS

function setupPageAccordions() {
    var allPanels = document.querySelectorAll('.accordion > dd');

    // Hide all panels initially
    allPanels.forEach(function(panel) {
        panel.style.maxHeight = '0'; // Set maxHeight to 0
        panel.style.overflow = 'hidden'; // Hide overflow
        panel.style.transition = 'max-height 0.4s ease-out'; // Smooth transition for height
    });

    var headers = document.querySelectorAll('.accordion dt a');

    headers.forEach(function(header) {
        // Set the initial SVG icon for each header on load (closed state)
        header.querySelector('small.right').innerHTML = `
             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9L12 15L18 9" stroke="#292524" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`;

        header.addEventListener('click', function(e) {
            e.preventDefault();

            var dt = this.closest('dt');
            var panel = dt.nextElementSibling;

            // Check if the panel is already open
            if (panel.style.maxHeight === '0px' || panel.style.maxHeight === '') {
                // Open the panel
                panel.style.maxHeight = (panel.scrollHeight + 12) + 'px';
                dt.classList.add('active');
                panel.classList.add('open');

                // Change to the "open" SVG icon (down arrow)
                this.querySelector('small.right').innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19" stroke="#292524" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`;
            } else {
                // Close the panel
                panel.style.maxHeight = '0';
                dt.classList.remove('active');
                panel.classList.remove('open');

                // Change to the "closed" SVG icon (horizontal line)
                this.querySelector('small.right').innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9L12 15L18 9" stroke="#292524" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`;
            }
        });
    });
}



 jQuery(function () {
		setupPageAccordions();
  });





